import { Component, computed, input, model } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { AlertComponent } from '@pedix-workspace/angular-ui-alert';
import {
  FormValidationComponent,
  InputCheckboxComponent,
} from '@pedix-workspace/angular-ui-form-reactive';

@Component({
  selector: 'pxw-shipping-continue-with-confirmation',
  templateUrl: './shipping-continue-with-confirmation.component.html',
  styleUrls: ['./shipping-continue-with-confirmation.component.scss'],
  imports: [
    TranslocoDirective,
    AlertComponent,
    FormValidationComponent,
    InputCheckboxComponent,
    FormsModule,
  ],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ShippingContinueWithConfirmationComponent {
  readonly isFormSubmitted = input.required<boolean>();
  readonly message = input.required<string>();

  readonly outOfDeliveryZoneConfirmed = model.required<boolean>();
}
